import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getAllBooks } from '../utils/api';
import Header from '../components/Header';

interface BookCard {
  _id: string;
  title: string;
  cost: number;
  description?: string;
  mainImage?: string;
}

const Shop: React.FC = () => {
  const [books, setBooks] = useState<BookCard[]>([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const load = async () => {
      try {
        const data = await getAllBooks();
        setBooks(data || []);
      } catch (e) {
        console.error(e);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  return (
    <>
      <Header title="Book Shop" />
      <div className="shop-container">
        <h1>Shop</h1>
        {loading ? (
          <p>Loading...</p>
        ) : (
          <div className="books-grid">
            {books.map((b) => (
              <div key={b._id} className="book-card" onClick={() => navigate(`/shop/${b._id}`)}>
                <div className="book-image">
                  {b.mainImage ? (
                    <a href={b.mainImage} target="_blank" rel="noreferrer">
                      <img src={b.mainImage} alt={b.title} />
                    </a>
                  ) : (
                    <div className="no-image">No Image</div>
                  )}
                </div>
                <div className="book-body">
                  <h3>{b.title}</h3>
                  <p className="price">₹{b.cost}</p>
                  <p className="desc">{b.description ? b.description.slice(0, 120) + (b.description.length > 120 ? '...' : '') : ''}</p>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </>
  );
};

export default Shop;
